import { Component, OnInit, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { configSections } from '../../services/user-config-panel.service';
import { UserConfigPanelService } from '../../services/user-config-panel.service';

@Component({
  selector: 'app-user-config-container',
  templateUrl: './user-config-container.component.html',
  styleUrls: ['./user-config-container.component.scss']
})

export class UserConfigContainerComponent implements OnInit {

  isMenuOpen: boolean = false;  // Estado del menú móvil
  public items: any[] = []
  public sectionMenu: any[] = []

  public configSections = configSections
  public selectedSubItem: string =  this.configSections.USER_PROFILE;
  public selectedSection: string = this.configSections.USER_PROFILE;

  constructor(
    private translate: TranslateService,
    private userConfigPanel : UserConfigPanelService,
  ) {
    this.loadMenuItems();

    // Escuchar cambio de idioma para actualizar etiquetas
    this.translate.onLangChange.subscribe(() => {
      this.loadMenuItems();
    });

    this.userConfigPanel.sectionConfigSelected$.subscribe((section)=>{
      this.selectedSection = section
      console.log(section, "update")
      if(this.sectionMenu.includes(section)){
        this.selectedSubItem = section
      }
    })
  }

  loadMenuItems() {
    this.translate.get([
      'CONFIGURATION.SECTIONS.USER.LABEL',
      'CONFIGURATION.SECTIONS.USER.USER_PROFILE.LABEL',
      'CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.LABEL',
      'CONFIGURATION.SECTIONS.USER.PASSWORD_CHANGE.LABEL',

      'CONFIGURATION.SECTIONS.PREFERENCES.LABEL',
      'CONFIGURATION.SECTIONS.PREFERENCES.THEME_CUSTOM.LABEL',
      'CONFIGURATION.SECTIONS.PREFERENCES.LANGUAGE_CONFIGURATION.LABEL',

      'CONFIGURATION.SECTIONS.CONFIGURATION.LABEL',
      'CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.LABEL'
    ]).subscribe(translations => {
      this.items = [
        {
          label: translations['CONFIGURATION.SECTIONS.USER.LABEL'],
          items: [
            {
              label: translations['CONFIGURATION.SECTIONS.USER.USER_PROFILE.LABEL'],
              icon: 'pi pi-user',
              section: this.configSections.USER_PROFILE,
              command: () => this.selectSection(this.configSections.USER_PROFILE)
            },
            {
              label: translations['CONFIGURATION.SECTIONS.USER.PASSWORD_CHANGE.LABEL'],
              icon: 'pi pi-key',
              section: this.configSections.PASSWORD_CHANGE,
              command: () => this.selectSection(this.configSections.PASSWORD_CHANGE)
            },
          ]
        },
        {
          label: "Plataforma",
          items: [
            {
              label: "Información",
              icon: 'pi pi-question-circle',
              section: this.configSections.PLATFORM_INFO,
              command: () => this.selectSection(this.configSections.PLATFORM_INFO)
            },
            {
              label: 'Módulos y Preferencias',
              icon: 'pi pi-th-large',
              section: this.configSections.VIEWS_PREFERENCES,
              command: () => {
                this.selectSection(this.configSections.VIEWS_PREFERENCES);
              }
            },
            {
              label: translations['CONFIGURATION.SECTIONS.CONFIGURATION.ICONS_CONFIGURATION.LABEL'],
              icon: 'pi pi-pencil',
              section: this.configSections.ICONS_CONFIGURATION,
              command: () => this.selectSection(this.configSections.ICONS_CONFIGURATION)
            },
            {
              label: translations['CONFIGURATION.SECTIONS.PREFERENCES.THEME_CUSTOM.LABEL'],
              icon: 'pi pi-palette',
              section: this.configSections.THEME_CUSTOM,
              command: () => this.selectSection(this.configSections.THEME_CUSTOM)
            },
          ]
        },
      ];
      this.getAllSectionsFromMenu()
    });
  }


  getAllSectionsFromMenu(): string[] {
    const sections: string[] = [];
    this.items.forEach(group => {
      group.items.forEach((subItem: any) => {
        if (subItem.section) {
          sections.push(subItem.section);
        }
      });
    });
    this.sectionMenu = sections
    return sections;
  }

  ngOnInit(): void {
  }

  selectSection(section: string): void {
    this.isMenuOpen = this.isMenuOpen ? false : true
    this.userConfigPanel.setSelectedSection(section)
  }

  onSubItemSelect(subItem: any) {
    this.selectedSubItem = subItem.section;  // Marca la subopción como seleccionada
    if (subItem.command) {
      subItem.command();  // Ejecuta la acción de selección
    }
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const menuElement = document.querySelector('.menu-mobile');
    if (menuElement && !menuElement.contains(event.target as Node)) {
      this.isMenuOpen = false; // Cierra el menú si el clic está fuera del área del menú
    }
  }

  onSectionChange(section: string) {
    console.log("open section show ", section)
    this.selectedSection = section;
  }
}
